import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Routes as Switch, Route, useLocation } from 'react-router-dom';
import { Box, Button, ContainerBox } from '@kis-technologies/kis-ui';
import { MenuPanel } from 'components/MenuPanel';
import { selectors as authSelectors } from 'store/auth';
import ForgotPasswordView from 'views/ForgotPasswordView';
import ResetPasswordView from 'views/ResetPasswordView';
import SignInView from 'views/SignInView';
import ProtectedRoutes from './ProtectedRoutes';
import { useStyles } from './styled';

const Routes: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  const [showMenuPanel, setShowMenuPanel] = useState(false);

  const isLoggedIn = useSelector(authSelectors.selectIsAuthenticated);

  const classes = useStyles({ isLoggedIn })();

  const onMenuClick = () => {
    setShowMenuPanel(true);
  };

  const onMenuPanelClose = () => {
    setShowMenuPanel(false);
  };

  return (
    <>
      <Box className={classes.outerBox}>
        <ContainerBox className={classes.containerBox}>
          <Box className={classes.menuButtonBox}>
            <Button className={classes.menuButton} onClick={onMenuClick}>
              Menu
            </Button>
          </Box>
          <Switch>
            <Route path="/" element={<SignInView />} />
            <Route path="/resetpassword/:token?" element={<ResetPasswordView />} />
            <Route path="/forgotpassword" element={<ForgotPasswordView />} />
            <Route path="/*" element={<ProtectedRoutes />} />
          </Switch>
        </ContainerBox>
      </Box>
      {showMenuPanel && <MenuPanel onClose={onMenuPanelClose} isOpen={showMenuPanel} routePath={path} />}
    </>
  );
};

export default Routes;
